export type MaintenanceWindow = {
  // ISO 8601 datetime strings — displayed in the user's local timezone
  startTime: string
  endTime: string
  // Short message shown in the banner, e.g. "We are upgrading our servers."
  message: string
}

// Phase 1: Set this to a MaintenanceWindow object when maintenance is scheduled.
// Phase 2: This export will be replaced by an API call in fetchMaintenanceConfig.
export let maintenanceConfig: MaintenanceWindow | null = {
  startTime: '2026-04-06T16:00:00-04:00',
  endTime: '2026-04-06T16:30:00-04:00',
  message: 'We are upgrading our servers.',
}
